const legalLinks: LegalLink[] = [
  { link: "/legal-notice", title: "legal-section.legal-notice" },
  { link: "/cookies-policy", title: "legal-section.cookies-policy" },
  { link: "/privacy-policy", title: "legal-section.privacy-policy" },
  {
    link: "/contract-conditions",
    title: "legal-section.contract-conditions",
  },
];

export { legalLinks };
